module.exports = __webpack_public_path__ + "static/media/Mail-tb-ico.0deb1968.svg";